import { Component } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { ConfigurationChartBarComponent } from '../configuration-chart-bar/configuration-chart-bar.component';
import { HeaderComponent } from '../../atoms/header/header.component';
import { ConfigurationChartScatterComponent } from '../configuration-chart-scatter/configuration-chart-scatter.component';
import { ConfigurationChartLineComponent } from '../configuration-chart-line/configuration-chart-line.component';
import { ConfigurationChartPieComponent } from '../configuration-chart-pie/configuration-chart-pie.component';
import { ConfigurationChartTableComponent } from '../configuration-chart-table/configuration-chart-table.component';
import { ConfigurationChartRadarComponent } from '../configuration-chart-radar/configuration-chart-radar.component';
import { ConfigurationChartPolarComponent } from '../configuration-chart-polar/configuration-chart-polar.component';
import { DividerModule } from 'primeng/divider';
@Component({
  selector: 'app-configuration-chart',
  standalone: true,
  imports: [
    PanelModule,
    ConfigurationChartBarComponent,
    HeaderComponent,
    ConfigurationChartScatterComponent,
    ConfigurationChartLineComponent,
    ConfigurationChartPieComponent,
    ConfigurationChartTableComponent,
    ConfigurationChartRadarComponent,
    ConfigurationChartPolarComponent,
    DividerModule,
  ],
  templateUrl: './configuration-chart.component.html',
  styleUrl: './configuration-chart.component.scss',
})
export class ConfigurationChartComponent {}
